import { ApplicationLanguages } from "../language/language"

export interface AuthModel{
    userDbId: number,
    publicId: string,
    token: string,
    expiryUtc: string,
    isLoginSuccessful: boolean,    
    passwordChangeRequiredDays: number,
    agentName: string,
    username:string,
    isParticipant:boolean,
    participantLastActiveLanguage:number,
    showBBLogo:boolean,
    provinceId:number,
    requiresTwoFactor?: boolean,
    twoFactorToken?: string
}

export function defaultAuthModelValues():AuthModel{
    return{userDbId:0,publicId:'',token:'',expiryUtc:'',isLoginSuccessful:false,passwordChangeRequiredDays:0,
        agentName:'',username:'',isParticipant:false,participantLastActiveLanguage:0,showBBLogo:true,provinceId:0,
        requiresTwoFactor:false,twoFactorToken:''
    }
}